/*eslint-disable*/
import React, { Fragment, useState, useCallback } from "react";;
import Material_React_Table from "../../components/React_Material_Table/Material_React_Table";
import { Box } from "@mui/material";
export default function NursePrescriptionForm(props) {
  const tableRef = React.createRef();
  const addActionRef = React.useRef();

  const [selectedUsers, setSelectedUsers] = useState([]);
  const [userSet, setUsers] = useState([]);
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const TitleImg = (rowData) => {
    return (
      <div>
        <input type="file" />
      </div>
    );
  };

  const showImage = () => {};

  const tableColumns = [
    {
      header: "Patient ID",
      accessorKey: "patientId",
      // validate: (rowData) => Boolean(rowData.patientId),
    },
    {
      header: "Patient Name",
      accessorKey: "patientName",
      // validate: (rowData) => Boolean(rowData.patientName),
    },
    {
      header: "Prescription",
      accessorKey: "prescription",
      // validate: (rowData) => Boolean(rowData.prescription),
    },

    {
      header: "Date",
      accessorKey: "date",
      type:"date"
      // validate: (rowData) => Boolean(rowData.date),
    },

    {
      header: "Upload Document",
      accessorKey: "uploadDocument",
      // render: (rowData) => <TitleImg rowData={rowData} />,
    },
    {
      header: "Consent Form",
      accessorKey: "consentForm",
      // render: (rowData) => <TitleImg rowData={rowData} />,
    },

    // {
    //   title: "Consent Form",
    //   field: "internal_action",
    //   editable: false,
    //   render: (rowData) =>
    //     rowData && (
    //       <IconButton
    //         color="secondary"
    //         onClick={() => addActionRef.current.click()}
    //       >
    //         <AddIcon />
    //       </IconButton>
    //     )
    // },
  ];

  const [tableData, setTableData] = useState([
    {
      patientId: "ytskckd343n",
      patientName: "Mthu",
      prescription: "Cough Syrup",

      date: "18-05-2022",
    },
    {
      patientId: "jfudgg4svd",
      patientName: "Tsepo",
      prescription: "Med Lemon",

      date: "18-05-2022",
    },
  ]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };


  
  
   const onRowAdd= (newData) =>{
              new Promise((resolve, reject) => {
                setTimeout(() => {
                  checkUserExists(newData).then((res) => {
                    if (res.users && res.users.length > 0) {
                      alert(language.user_exists);
                      reject();
                    } else if (res.error) {
                      alert(language.email_or_mobile_issue);
                      reject();
                    } else {
                      newData["createdByAdmin"] = true;
                      newData["userType"] = "nophonepatient";
                      newData["createdAt"] = new Date().toISOString();
                      newData["referralId"] =
                        newData.firstName.toLowerCase() +
                        Math.floor(1000 + Math.random() * 9000).toString();
                      let role = auth.info.profile.userType;
                      if (role === "practiceadmin") {
                        newData["practiceadmin"] = auth.info.uid;
                        newData["practiceNumber"] =
                          auth.info.profile.practiceNumber;
                      } else if (role === "nurse") {
                        newData["nurse"] = auth.info.uid;
                        newData["practiceNumber"] =
                          auth.info.profile.practiceNumber;
                      } else if (role === "doctor") {
                        newData["doctor"] = auth.info.uid;
                        newData["practiceNumber"] =
                          auth.info.profile.practiceNumber;
                      }
                      dispatch(addUser(newData));
                      resolve();
                    }
                  });
                }, 600);
              })};
  
  
    const     onRowUpdate= (newData, oldData) =>{
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  dispatch(editUser(oldData.id, newData));
                }, 600);
              })
            };
  
  
    const   onRowDelete= (oldData) =>{
              features.AllowCriticalEditsAdmin
                ? new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      dispatch(deleteUser(oldData.id));
                    }, 600);
                  })
                : new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      alert(language.demo_mode);
                    }, 600);
                  })
        };
  // const handleBulkDelete = () => {
  //   const updatedData = tableData.filter(row => !selectedRows.includes(row))
  //   setTableData(updatedData)
  // }

  return (
   <Box>
    {/* <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
      {commonAlert.msg}
    </AlertDialog> */}
    <Material_React_Table
      data={data}
      columns={columns}
      userInitialState={{
        columnVisibility: { consentForm   : false }, // This hides the "id" column initially
      }}
      onRowAdd={onRowAdd}
      onRowUpdate={onRowUpdate}
      onRowDelete={onRowDelete}
    />
  </Box>
  );
}
